import { useEffect } from "react";

const OAuthGitHubFinish: React.FC = () => {
  useEffect(() => {
    // Send message to parent window
    if (window.opener) {
      // Use window.location.origin to restrict origin and prevent Cross-Origin vulnerability
      window.opener.postMessage(
        "github-app-install-success",
        window.location.origin,
      );
      window.close();
    }
  }, []);
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-green-600 mb-4">All set 🎉</h2>
        <p className="text-gray-600">You can close this window.</p>
      </div>
    </div>
  );
};

export default OAuthGitHubFinish;
